var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--main"
  }, [_c('div', {
    staticClass: "visual d-flex align-center color-white"
  }, [_c('v-container', [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani mb-6 mb-lg-18"
  }, [_c('p', {
    staticClass: "page-text font-weight-bold"
  }, [_vm._v(" 전자혁신제조플랫폼 ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h2', {
    staticClass: "tit--lg line-height-11"
  }, [_vm._v(" 한국전자정보통신산업진흥회 ")])]), _c('div', {
    staticClass: "text-ani mb-16 mb-lg-34"
  }, [_c('h2', {
    staticClass: "tit--lg line-height-11"
  }, [_vm._v(" (KEA) 전자제조센터 ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-regular"
  }, [_vm._v(" 설계, 개발, 제작, 조립, 검사를 지원기업과 "), _c('b', {
    staticClass: "font-size-18 font-size-md-24"
  }, [_vm._v("공동진행")]), _vm._v("합니다. ")])])])])], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit--lg line-height-1 font-weight-bold mb-8 mb-lg-20"
  }, [_vm._v(" CATEGORY ")]), _c('h5', {
    staticClass: "tit-txt font-weight-regular"
  }, [_vm._v(" 간편한 클릭으로 원하는 페이지로 이동하세요 ")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('main-card-icon', {
    attrs: {
      "link": "/join/type",
      "tit": "회원가입",
      "sc": "기업회원 · 일반회원",
      "icon": "/images/main/s1-icon1.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('main-card-icon', {
    attrs: {
      "link": "/service/about",
      "tit": "e만듦",
      "sc": "전자제조지원 서비스",
      "icon": "/images/main/s1-icon2.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('main-card-icon', {
    attrs: {
      "link": "https://yknowledge.uxi.kr/",
      "target": "_blank",
      "tit": "e이음",
      "sc": "전문가 · 기업연결",
      "icon": "/images/main/s1-icon3.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('main-card-icon', {
    attrs: {
      "link": "https://goecircle.kr/",
      "target": "_blank",
      "tit": "e바꿈",
      "sc": "피드백·스케일업",
      "icon": "/images/main/s1-icon4.png"
    }
  })], 1)], 1)], 1)], 1), _c('v-container', [_c('v-divider')], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "mb-40 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "5"
    }
  }, [_c('tit-primary', {
    attrs: {
      "className": "mb-20 mb-lg-74",
      "sc": "COMMUNITY",
      "tit": "한국전자정보통신산업진흥회의 다양한 소식을 확인해 보세요. "
    }
  }), _c('arrow-btn', {
    attrs: {
      "link": "/community/notice"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "main-board-wrap pl-lg-42"
  }, [_c('v-tabs', {
    attrs: {
      "height": "36"
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v("공지사항")]), _c('v-tab', [_vm._v("자료실")])], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('main-notice')], 1), _c('v-tab-item', [_c('main-reference')], 1)], 1)], 1)])], 1)], 1)], 1), _c('section', {
    staticClass: "section",
    staticStyle: {
      "background-image": "url(/images/main/s3-bg.jpg)"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('v-row', {
    attrs: {
      "align-lg": "end"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-lg-0",
    attrs: {
      "col": "12",
      "lg": "auto"
    }
  }, [_c('tit-primary', {
    attrs: {
      "className": "mb-0",
      "sc": "Partners",
      "tit": "KEA 산업혁신 파트너 "
    }
  })], 1), _c('v-spacer', {
    staticClass: "d-none d-lg-block"
  }), _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "slide-btn slide-btn--prev mr-4 mr-lg-8",
    attrs: {
      "icon": "",
      "x-large": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow"
  })]), _c('v-btn', {
    staticClass: "slide-btn slide-btn--next",
    attrs: {
      "icon": "",
      "x-large": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow"
  })])], 1)], 1)], 1), _c('div', {
    staticClass: "partners-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "thumb-wrap mb-10 mb-lg-20"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner1.jpg)"
    }
  })]), _c('div', {
    staticClass: "thumb-wrap"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner2.jpg)"
    }
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "thumb-wrap mb-10 mb-lg-20"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner3.jpg)"
    }
  })]), _c('div', {
    staticClass: "thumb-wrap"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner4.jpg)"
    }
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "thumb-wrap mb-10 mb-lg-20"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner5.jpg)"
    }
  })]), _c('div', {
    staticClass: "thumb-wrap"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner6.jpg)"
    }
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "thumb-wrap mb-10 mb-lg-20"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner7.jpg)"
    }
  })]), _c('div', {
    staticClass: "thumb-wrap"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner8.jpg)"
    }
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "thumb-wrap mb-10 mb-lg-20"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner9.jpg)"
    }
  })]), _c('div', {
    staticClass: "thumb-wrap"
  }, [_c('div', {
    staticClass: "thumb",
    staticStyle: {
      "background-image": "url(/images/main/partner10.jpg)"
    }
  })])])])])])])], 1), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }